export const noDataComponent = "No hay registros para mostrar";

export const typeList = [
  { value: "black", label: "Lista Negra" },
  // { value: "white", label: "Lista Blanca" },
  // { value: "debt", label: "Lista de Deudores" },
];

export const status = [
  { value: "enabled", label: "Activo" },
  { value: "disabled", label: "Inactivo" },
  { value: "blocked", label: "Bloqueado" },
];

export const typeValue = [
  { value: "business_name", label: "Empresa" },
  { value: "email", label: "Correo" },
  { value: "phone", label: "Teléfono" },
  { value: "name", label: "Nombre" },
  { value: "address", label: "Dirección" },
  { value: "clabe", label: "CLABE" },
  { value: "taxid", label: "RFC" },
  { value: "populationid", label: "CURP" },
  { value: "uuid", label: "UUID" },
  { value: "card_number", label: "Tarjeta" },
  { value: "ip", label: "IP" },
  { value: "device_id", label: "ID Dispositvo" },
  { value: "fingerprint", label: "Fingerprint" },
  { value: "geohash", label: "Geohash" },
];

export const address = [
  { value: "zip", label: "Código postal" },
  { value: "country", label: "País" },
  { value: "town", label: "Alcadia / Municipio" },
  { value: "street", label: "Calle" },
  { value: "locality", label: "Colonia" },
  { value: "state", label: "Estado" },
  { value: "extnum", label: "N° Ext." },
  { value: "intnum", label: "N° Int." },
];

export const name = [
  { value: "gname", label: "Nombre" },
  { value: "lname", label: "Apellido paterno" },
  { value: "sname", label: "Apellido materno" },
  { value: "bdate", label: "Fecha de Nacimiento" },
];

export const corporate = [
  { value: "corporate_name", label: "Empresa" },
  { value: "bdate", label: "Fecha de Constitución" },
];

export const permissions = [
  { key: "read", label: "Lectura" },
  { key: "write", label: "Escritura" },
  { key: "hidden", label: "Oculto" },
];

export const severity = [
  { key: "monitoring", label: "Monitoreo" },
  { key: "blocked", label: "Bloqueo" },
];
export const labels = [
  { key: "deposito_garantia", label: "Depósito Garantía" },
  { key: "commission", label: "Comisión" },
];

export const allStatus = [
  { key: "ordered", label: "Ordenada" },
  { key: "confirmed", label: "Confirmada" },
  { key: "customizing", label: "Personalizando" },
  { key: "sent", label: "Enviada" },
  { key: "received", label: "Recibida" },
  { key: "on_hold", label: "Detenida" },
  { key: "on_transit", label: "En tránsito" },
  { key: "on_report", label: "En reporte" },
  { key: "unassigned", label: "Por activar" },
  { label: "Todos" },
];

export const cardsStatus = [
  { key: "enabled", label: "Activa" },
  { key: "disabled", label: "Inactiva" },
  { key: "ordered", label: "Ordenada" },
  { key: "confirmed", label: "Confirmada" },
  { key: "customizing", label: "Personalizando" },
  { key: "sent", label: "Enviada" },
  { key: "received", label: "Recibida" },
  { key: "on_hold", label: "Detenida" },
  { key: "on_transit", label: "En tránsito" },
  { key: "on_report", label: "En reporte" },
  { key: "unassigned", label: "Por activar" },
];

export const partners = [
  { label: "Todos", value: "Todos" },
  { label: "Cacao", value: "albo-partner-cacaopay-paycard" },
  { label: "Tutuka", value: "albo-partner-tutuka" },
];

export const version = [{ key: "v1", label: "Version 1" }];

export const typeLimits = [
  { key: "customer", label: "Cliente" },
  { key: "space_account", label: "Espacios" },
  { key: "both", label: "Ambos" },
];

export const importOptions = [
  { key: "0", value: "0", label: "Si" },
  { key: "1", value: "1", label: "No" },
  { key: "2", value: "2", label: "Parcial" },
];
export const statusOptions = [
  { key: "1", value: "101", label: "Pendiente" },
  { key: "2", value: "102", label: "Concluida" },
  { key: "3", value: "103", label: "Reapertura pendiente" },
  { key: "4", value: "104", label: "Reapertura concluida" },
];
export const channelOptions = [
  { key: "1", value: "201", label: "Página web" },
  { key: "2", value: "202", label: "Teléfono fijo" },
  { key: "3", value: "203", label: "Teléfono celular" },
  { key: "4", value: "204", label: "Personal" },
  { key: "5", value: "205", label: "Correo electrónico" },
  { key: "6", value: "206", label: "CONDUSEF" },
];
export const claimsOptions = [
  { key: "1", value: "301", label: "Evento Único" },
  { key: "2", value: "302", label: "Evento Múltiple" },
];
export const reasonOptions = [
  { key: "1", value: "401", label: "Producto no reconocido" },
  { key: "2", value: "402", label: "Error operativo de la Institución" },
  { key: "3", value: "403", label: "Error operativo del cliente" },
  { key: "4", value: "404", label: "Suplantación o robo de identidad" },
  { key: "5", value: "499", label: "Por definir" },
];
export const eventOptions = [
  { key: "1", value: "501", label: "Cargo no reconocido por consumos efectuados" },
  { key: "2", value: "502", label: "Cobro no reconocido por comisiones" },
  { key: "3", value: "503", label: "Cobro no reconocido por otras comisiones" },
  { key: "4", value: "504", label: "Abono no acreditado" },
  { key: "5", value: "505", label: "Devolución no aplicada" },
  { key: "6", value: "506", label: "Cantidad solicitada no entregada" },
  { key: "7", value: "507", label: "Pago automático mal aplicado total o parcialmente (domiciliaciones)"},
  { key: "8", value: "508", label: "Pago no acreditado" },
  { key: "9", value: "509", label: "Transferencia no reconocida" },
  { key: "10", value: "510", label: "Retiro no reconocido" },
  { key: "11", value: "511", label: "Transferencia no acreditada" },
  { key: "12", value: "512", label: "Pago duplicado" },
  { key: "13", value: "513", label: "Discrepancias con el tipo de cambio" },
  { key: "14", value: "599", label: "Por definir" },
];
export const operationOptions = [
  { key: "1", value: "601", label: "Aplicación móvil" },
  { key: "2", value: "602", label: "Operaciones por internet" },
  { key: "3", value: "603", label: "Comercio por internet" },
  { key: "4", value: "604", label: "Comercio por teléfono" },
  { key: "5", value: "605", label: "Cajeros automáticos" },
  { key: "6", value: "606", label: "Terminal punto de venta" },
  { key: "7", value: "607", label: "Sucursales" },
  { key: "8", value: "608", label: "Comisionista" },
  { key: "9", value: "609", label: "Movs. generados por la Institución" },
  { key: "10", value: "610", label: "Movs. generados por la Institución AUT" },
  { key: "11", value: "699", label: "Por definir" },
];
export const resolveOptions = [
  { key: "1", value: "701", label: "Cliente desistió (Improcedente)" },
  { key: "2", value: "702", label: "Falta documentación del Cliente (Improcedente)" },
  { key: "3", value: "703", label: "Plazo vencido al cliente (Improcedente)" },
  { key: "4", value: "704", label: "Reclamación reportada en más de una ocasión (Improcedente)"},
  { key: "5", value: "705", label: "Evidencia a favor de la Institución (Improcedente)" },
  { key: "6", value: "706", label: "Por normativa (Procedente)" },
  { key: "7", value: "707", label: "Evidencia a favor del cliente (Procedente)" },
  { key: "8", value: "708", label: "Plazo vencido a la Institución (Procedente)" },
  { key: "9", value: "709", label: "Por política interna (Procedente)" }
];

export const accountType = [
  { key: "1", value: "cuenta", label: "Cuenta" },
  { key: "2", value: "fideicomiso", label: "Fideicomiso" },
];

export const catalogFraudOperation = [
  { key: 1, value: "moneyout", label: "Money-out" },
  { key: 2, value: "moneyin", label: "Money-in" },
  { key: 3, value: "payment", label: "Payment" }
];

export const catalogFraudChannel = [
  { key: 1, value: "external", label: "External" },
  { key: 2, value: "billpayments", label: "Billpayments" },
  { key: 3, value: "domestic", label: "Domestic" },
  { key: 4, value: "tutuka", label: "Tutuka" },
  { key: 5, value: "spei-in", label: "Spei-in" },
  { key: 5, value: "banxico.spei", label: "Banxico Spei" },
];

export const fraudTypeList = [
  { name: "blacklist", title: "Lista Negra" },
  { name: "whitelist", title: "Lista Blanca" },
  { name: "accumulator", title: "Accumulators" },
  { name: "configAcc", title: "Configuración Acc." },
  { name: "reboot", title: "Reboots" },
];

export const rolesType = [
  { key: "inext-role-customerService-manager", value: "CS-M", label: "CS Manager"},
  { key: "inext-role-customerService-specialist", value: "CS-E", label: "CS Especialista"},
  { key: "inext-role-compliance-manager", value: "C-M", label: "Compliance Manager"},
  { key: "inext-role-compliance-analyst", value: "C-A", label: "Compliance Analista"},
  { key: "inext-role-logistics-operations", value: "L-O", label: "Logística Operación"},
  { key: "inext-role-logistics-manager", value: "L-M", label: "Logística Manager"},
  { key: "inext-role-afb-kam", value: "A-AFB", label: "Analista aFB"},
  { key: "inext-role-afb-support", value: "S-AFB", label: "Soporte aFB"},
  { key: "inext-role-IT-Ops", value: "IT", label: "IT Ops"},
  { key: "inext-role-c-level", value: "C-L", label: "C-Level"},
  { key: "inext-role-growth", value: "G", label: "Growth"},
  { key: "inext-role-fraud-manager", value: "F", label: "Fraude"},
  { key: "inext-role-rewards-manager", value: "R", label: "Rewards Manager"},
  { key: "inext-role-spei-operator", value: "OS", label: "Operador SPEI"},
  { key: "inext-role-treasury-specialist", value: "TS", label: "Treasury Specialist"}
];

export const menuType = [
  { value: 'principal', label:'Principal'},
  { value: 'secondary', label:'Secundario'}
];

export const categoryMenu = [
  { value: 'It Ops', label:'It Ops'},
  { value: 'AFB', label:'AFB'},
  { value: 'Compliance', label:'Compliance'},
  { value: 'Customer', label:'Customer'},
  { value: 'Logistica', label:'Logistica'}
];

export const statusBatchConfig = [
  { value: 'pending', label:'Pendiente'},
  { value: 'in_progress', label:'En proceso'},
  { value: 'completed', label:'Completado'}
];

export const batchResult = {
  processed: 'Procesado',
  pending: 'Pendiente',
  total: 'Total'
};

export const batchType = [
  { value: 'email', label:'email'},
  { value: 'push', label:'Push'},
  { value: 'sms', label:'SMS'},
  { value: 'notification_center', label:'Notification Center'},
];

export const riskInfo = [
  { key: "Bajo", label: "rB" , css: "rec_b"},
  { key: "Medio", label: "rM" , css: "rec_s"},
  { key: "Alto", label: "rA" , css: "rec_ra"},
];

export const statusInfo = [
  { key: "enabled", label: "Activo" },
  { key: "disabled", label: "Inactivo" },
  { key: "blocked", label: "Bloqueado" },
  { key: "under_observation", label: "En observación" },
];

export const kycStatus = [
  { key: "profile", label: "Perfil Transaccional" },
  { key: "pep", label: "Cuestionario PEP" },
  { key: "risk_data", label: "KYC Complementario" },
  { key: "cash_data", label: "Cuestionario de Efectivo" },
];

export const searchOptions = [
  { key: "email", label: "Email" },
  { key: "phone", label: "Teléfono" },
  { key: "name", label: "Nombre" },
  { key: "uuid", label: "UUID" },
  { key: "clabe", label: "CLABE" },
  { key: "populationid", label: "CURP" },
  { key: "taxid", label: "RFC" },
  { key: "cashin", label: "CashIn" },
  { key: "operation", label: "Operación" }
]

export const channelTxs = [
  {key: "gestopago.billpayments", label: "Pago de Servicios"},
  {key: "stp.spei", label: "SPEI"},
  {key: "albo.mirai", label: "Domesticas e Internas"},
  {key: "openpay.cashin", label: "Openpay"},
  {key: "mc.ttk", label: "Pagos con tarjeta"},
  {key: "pespay.cashin", label: "PESPay"},
  {key: "dapp.cashin", label: "Dapp"},
  {key: "albo.cacao", label: "Cacao"},
];
export const statusTxs = [
  { key: "reversed", label: "Reversado"},
  { key: "approved", label: "Aprobada"},
  { key: "deleted", label: "Eliminada"},
  { key: "on_transit", label: "En tránsito"},
  { key: "confirmed", label: "Confirmada"},
  { key: "settled", label: "En firme"},
  { key: "declined", label: "Declinada"},
  { key: "failed", label: "Fallida"},
  { key: "accepted", label: "Aceptada"},
];

export const typeAfbCards = [
  { key: "worker", label: "Trabjador"},
];
export const statusAfbCards = [
  { key: "generated", label: "Solicitud generada" },
  { key: "ordered", label: "Ordenada" },
  { key: "confirmed", label: "Confirmada" },
  { key: "customizing", label: "Personalizando" },
  { key: "sent", label: "Enviada" },
  { key: "on_transit", label: "En tránsito" },
  { key: "unassigned", label: "Por activar" },
  { key: "acknowledged", label: "Recibida por el cliente" },
  { key: "active", label: "Activa" },
];

export const searchTypesAfb = [
  { key: "company_name", label: "Razón Social" },
  { key: "request_key", label: "Referencia" },
  { key: "customer_uuid", label: "UUID" },
  { key: "tax_id", label: "RFC" },
];

export const chargebacksStatus = [
  { name: "approved", title: "Aprobada" },
  { name: "declined", title: "Rechazada" },
  { name: "started", title: "En proceso" },
];

export const chargebacksType = [
  { name: "fraude", title: "Fraude" },
  { name: "anexo-8", title: "Anexo 8" },
  { name: "disputa-cacao", title: "Cargos no reconocidos cacao" },
  { name: "internacional", title: "Cargos Internacionales" },
  { name: "cargos-cacao", title: "Contracargos cacao" },
  { name: "r27", title: "R27" },
];

export const scvStatus = [
  { key: "albo_status", color: "#3743aa" },
  { key: "abea_status", color: "#27d6d1" },
  { key: "albit_status", color: "#6cb156" },
  { key: "albo_virtual_card", color: "#b15674" },
  { key: "albo_phys_card", color: "#a056b1" },
];

export const scvProductStatus = [
  { name: "enabled", title: "Activo" },
  { name: "lead", title: "Lead" },
  { name: "disabled", title: "Inactivo" },
  { name: "invalidated", title: "Inválido" },
  { name: "rejected", title: "Rechazado" }
];

export const scvAbeaStatus = [
  { name: "assigned", title: "Asignado" },
  { name: "accepted", title: "Aprobado" },
  { name: "closed", title: "Cerrado" },
  { name: "delayed", title: "Retrasado" },
];

// CRM -----------------------------------------------------------------------------------------------------------
export const crmTabs = [
  { note: "Nota", text: "registrada por", message: "Toma notas sobre este registro para realizar un seguimiento de la información importante."},
  { email: "Correo",  text: "enviado por", message: "Registra tus correos enviados o recibidos desde tu cliente de correo electrónico."},
  { call: "Llamada",  text: "registrada por", message: "Llama a un contacto y registra una actividad de llamada para realizar un seguimiento de tu discusión y tus notas."},
  { task: "Tarea",  text: "asignada a", message: "No hay tareas para mostrar.", image: "emptyTask"},
  { meet: "Eventos",  text: "registrada por", message: "No hay eventos para mostrar.", image: "emptyCalendar"},
  { activity: "Actividad",  text: "registrada por", message: "Aún no tienes actividades registradas."},
  { history: "Historial",  text: "registrado por", message: "Aún no tienes registros archivados."}
];

// CRM aFB ------------------------------------------------------------------------------
export const crmAfbData = {
  sections: [
    { title: 'Acerca de esta empresa', sectionName: 'generalCompany'},
    { title: 'Acerca de este contacto', sectionName: 'generalContact'},
  ],
  mainNode: 'general',
  createContact: 'generalContact',
  createCompany: 'generalCompany',
  createCompanyGroup: 'generalCompanyGroup',
  companyStatus: [
    { key: "lead", label: "Lead" },
    { key: "mql", label: "MQL" },
    { key: "sql", label: "SQL" },
    { key: "opportunity", label: "Opportunity" },
    { key: "account_created", label: "Account Created" },
    { key: "nMAB", label: "nMAB / Cliente" },
    { key: "dropout", label: "Abandono" },
    { key: "rejected", label: "Rechazado" },
  ],
  platformStatus: "abb_status_lead",
  contactStatus: [
    { key: "new", label: "Nuevo", bgcolor: "#B3E7FE9e", color: "#014665", color1: 'info' },
    { key: "in_process", label: "En proceso", bgcolor: "#FED9809C", color: "#CB8F01", color1: 'warning' },
    { key: "interview_asigned", label: "Entrevista agendada", bgcolor: "#92AFEA7C", color: "#3743AA", color1: 'info' },
    { key: "last_lead", label: "Último lead", bgcolor: "#D1E7CB", color: "#3E6930", color1: 'success' },
    { key: "not_qualified", label: "No calificado", bgcolor: "#EDABAE9C", color: "#972125", color1: 'error' },
    { key: "mql", label: "MQL", bgcolor: "#CB94D47C", color: "#A14EAE", color1: 'secondary' },
    { key: "sql", label: "SQL", bgcolor: "#CB94D47C", color: "#A14EAE", color1: 'secondary' },
    { key: "disabled", label: "Inactivo", bgcolor: "#a6b0b49e", color: "#000000", color1: 'secondary' },
    { key: "deal", label: "Deal", bgcolor: "#75d3a09e", color: "#000000", color1: 'secondary' },
  ],
  trackingStatus: [
    { key: "no_contact", label: "Sin contacto" },
    { key: "no_answer", label: "No contesto" },
    { key: "call_back_later", label: "Llamar más tarde" },
    { key: "successful_contact", label: "Contacto exitoso" },
    { key: "hang_up_call", label: "Cuelga llamada" },
    { key: "credit_product", label: "Interesado en producto de crédito" },
    { key: "do_not_contact", label: "No contactar" },
  ],
  origin_platform: [
    { key: "afb_web", label: "Sitio Web" },
    { key: "afb_web_mkt", label: "Marketing" },
    { key: "call", label: "Llamada en frío" },
    { key: "referral_employees", label: "Programa de referidos (Empleados)" },
    { key: "referral_client", label: "Programa de referidos (Clientes)" },
    { key: "promotor", label: "Promotor" },
    { key: "linkedin", label: "LinkedIn" },
    { key: "partnerships", label: "Partnerships" },
    { key: "networking", label: "Networking" },
    { key: "bdd_ale", label: "BDD Ale" },
    { key: "bdd_asf", label: "BDD ASF" },
    { key: "growth", label: "Growth" },
  ],
  app_uuid: [
    { key: "afb", label: "albo empresa cuenta (aFB)" },
    { key: "deltai", label: "albo empresa (delt.ai)" },
    { key: "retail", label: "albo cuenta (retail)" },
    { key: "abea", label: "albo (abea)" },
  ],
  phoneCall: [
    { key: 1, label: 1 },
    { key: 2, label: 2 },
    { key: 3, label: 3 },
    { key: 4, label: 4 },
    { key: 5, label: 5 },
  ],
  afbEmployees: [
    { key: "1 a 10 personas", label: "1 a 10 personas" },
    { key: "11 a 50 personas", label: "11 a 50 personas" },
    { key: "51 a 100 personas", label: "51 a 100 personas" },
    { key: "101 a 250 personas", label: "101 a 250 personas" },
    { key: "más de 250 personas", label: "Más de 250 personas" },
    { key: "Trabajador independiente", label: "Trabajador independiente" }
  ],
  afbTypeCompany: [
    { key: "PM", label: "Persona Moral - Empresa" },
    { key: "PFAE", label: "Persona Física con Actividad empresarial" }
  ],
  afbAccountType: [
    { key: "vip", value: true, label: "VIP" },
    { key: "no_vip", value: false, label: "No VIP" }
  ],
  afbMainUse: [
    { key: "salaries", label: "Salarios" },
    { key: "bonus", label: "Bonos" },
    { key: "commissions", label: "Comisiones" },
    { key: "payments", label: "Pagos a proveedores" },
    { key: "none", label: "Ninguno" },
    { key: "others", label: "otros" },
  ],
  afbMethodPayment: [
    { key: "cash", label: "Efectivo" },
    { key: "spei", label: "Banco / SPEI" },
    { key: "valera", label: "Valera" },
    { key: "other", label: "Otro" },
  ],
  afbReasonReject: [
    { key: "1", label: "Busca tarjeta corporativa" },
    { key: "2", label: "El producto no cumple con lo que busca" },
    { key: "3", label: "No le interesa" },
    { key: "4", label: "No responde correos / llamadas" },
  ],
  afbHelp: [
    { key: "yes", label: "Si" },
    { key: "yes_no_advance", label: "Si, sin avance" },
    { key: "not_now", label: "No ahora" },
    { key: "not_connected", label: "No conectado" },
  ],
  afbRaiting: [
    { key: "c-level", label: "C-Level" },
    { key: "directors", label: "Directors" },
    { key: "managers", label: "Managers" }
  ],
  crmLowFunnel: [
    { key: 'opportunity', label: 'Oportunidad Creada'},
    { key: 'documentation', label: 'Documentación'},
    { key: 'signed_contract', label: 'Contrato firmado'},
    { key: 'won_opportunity', label: 'Oportunidad ganada'},
    { key: 'lost_opportunity', label: 'Oportunidad perdida'},
    { key: 'on_hold', label: 'On Hold'},
    { key: 'nMAB_done', label: 'nMAB'}
  ]
}

export const crmAfbInfo = [
  {generalContact: [
    { key: "gname", label: "Nombre(s)", section: "general", aux_label: "(Obligatorio)", required: true},
    { key: "lname", label: "Apellidos", section: "general", aux_label: "(Obligatorio)", required: true},
    { key: "email", label: "Correo electrónico", section: "general", aux_label: "(Obligatorio)", required: true},
    { key: "onboarding_email", label: "Correo de registro del Onboarding", section: "general", required: false},
    { key: "phone", label: "Teléfono celular", section: "general", aux_label: "(Obligatorio)", required: true},
    { key: "phone_office", label: "Teléfono oficina", section: "general", required: false},
    { key: "company_role", label: "Rol en la empresa", required: false},
    { key: "company_name", label: "Empresa principal", section: "general", required: false},
    { key: "city", label: "Ciudad", section: "general", required: false},
    { key: "raiting", label: "Raiting", catalog: "afbRaiting", required: false},
    { key: "app_uuid", label: "App", catalog: "app_uuid", aux_label: "(Obligatorio)", required: true},
  ]},
  {generalCompany: [
    { key: "company_name", label: "Nombre comercial", section: "general", aux_label: "(Obligatorio)", required: true},
    { key: "corporate_name", label: "Razón social", section: "general", required: false},
    { key: "account_type", label: "Tipo de cuenta", section: "general", catalog: "afbAccountType", aux_label: "(Obligatorio)", required: true},
    { key: "city", label: "Ciudad", section: "general", required: false},
    { key: "company_group", label: "Grupo empresarial", section: "general", aux_label: "(Obligatorio)", required: true},
    { key: "segment", label: "Segmento", section: "general", aux_label: "(Obligatorio)", required: true},
    { key: "revenue", label: "Monto (Revenue)", section: "revenue", text: true},
    { key: "nMAB", label: "Revenue nMAB", section: "revenue", required: false},
    { key: "nMAW", label: "Revenue nMAW", section: "revenue", required: false},
    { key: "nMAD", label: "Revenue nMAD", section: "revenue", required: false},
    { key: "industry", label: "Industria", section: "general", required: false},
    { key: "charge_fee", label: "Cobro de Fee", required: false},
    { key: "onboarding_email", label: "Correo de registro del Onboarding", section: "general", aux_label: "(Obligatorio)", required: true},
    { key: "employees_quantity_desc", label: "Número de workers", catalog: "afbEmployees", section: "general", required: false},
    { key: "type", label: "Somos persona", catalog: "afbTypeCompany", section: "general", required: false},
    { key: "website_url", label: "Sitio web", section: "general", required: false},
    { key: "company_email", label: "Correo alternativo", section: "general", required: false},
    { key: "company_phone", label: "Teléfono alternativo", section: "general", required: false},
    { key: "rejection_reason", label: "Razón de rechazo", catalog: "afbReasonReject", section: "result", required: false},
    { key: "rejection_detail", label: "Detalle del rechazo", section: "result", required: false},
    { key: "app_uuid", label: "App", catalog: "app_uuid", aux_label: "(Obligatorio)", required: true}
  ]},
  {generalCompanyGroup: [
    { key: "group_name", label: "Nombre", aux_label: "(Obligatorio)", required: true},
    { key: "charge_fee", label: "Cobro de Fee", required: false},
  ]},
]

export const compliancePriority = [
  { key: 0, label: "No aplica" },
  { key: 1, label: "Alta" },
  { key: 2, label: "Media-alta" },
  { key: 3, label: "Media" },
  { key: 4, label: "Media-baja" },
  { key: 5, label: "Baja" },
];

export const rewardsTxType = [
  { key: 'internal', label:'Interna'},
  { key: 'external', label:'Externa'}
];

export const rewardsLevelType = [
  { key: 'level_1', label:'Nivel 1'},
  { key: 'level_2', label:'Nivel 2'},
  { key: 'level_3', label:'Nivel 3'},
  { key: 'level_4', label:'Nivel 4'},
  { key: 'level_5', label:'Nivel 5'},
  { key: 'level_6', label:'Nivel 6'},
];

export const widgetDescription = {
  dataPersonal:'Datos Personales',
  findStatementClients:'Estado de Cuenta',
  cuentas: "Cuentas",
  spaceListTx: "Movimientos"
};

export const taxStatus = [
  { key: 'not_found', label: 'La referencia de pago no se encuentra registrada.'},
  { key: 'failed', label: 'El pago no fue procesado.'},
  { key: 'send', label:'El pago está siendo procesado.'},
  { key: 'done', label:'El pago fue realizado con éxito.'}
];

export const percentageCommission = [
  { key: 1, label:'1 %'},
  { key: 2, label:'2 %'},
  { key: 3, label:'3 %'},
  { key: 4, label:'4 %'},
  { key: 5, label:'5 %'},
  { key: 6, label:'6 %'},
  { key: 7, label:'7 %'},
  { key: 8, label:'8 %'},
  { key: 9, label:'9 %'},
  { key: 10, label:'10 %'},
  { key: 11, label:'11 %'},
  { key: 12, label:'12 %'}
];

export const sellerRole = [
  { key: "agent", label: "Agente" },
  { key: "promoter", label: "Promotor" },
];
export const sellerType = [
  { key: "head", label: "HEAD", role: "agent" },
  { key: "kam", label: "KAM", role: "agent" },
  { key: "ae", label: "AE", role: "agent" },
  { key: "sdr", label: "SDR", role: "agent" },
  { key: "internal", label: "Interno", role: "promoter" },
  { key: "external", label: "Externo", role: "promoter" },
];

export const statusConstitutiveAct = [
  { key: "match", label: "Coincide", color: "#3E6930", backgroundColor: "#E8F5E9"},
  { key: "mismatch", label: "No coincide", color: "#72050a", backgroundColor: "#FFDADE"},
  { key: "fix", label: "Por validar", color: "#F57C00", backgroundColor: "#FFF4D0"},
  { key: "unknown", label: "Sin estatus", color: "#363636", backgroundColor: "#E6E6E6"}
];

export const constitutiveAct = [
  { key: "document_issue_date", label: "Fecha de emisión", type: "date" },
  { key: "incorporation_date", label: "Fecha de constitución de la sociedad", type: "date" },
  { key: "legal_name", label: "Razón social de la empresa moral", type: "string" },
  // { key: "trade_name", label: "Nombre comercial de la empresa moral", type: "string" },
  { key: "society_type", label: "Tipo de sociedad", type: "string" },
  { key: "tax_id", label: "RFC de la persona moral", type: "string" },
  { key: "address", label: "Dirección de la empresa", type: "object" },
  { key: "economic_activity", label: "Actividad económica de la persona moral", type: "string" },
  { key: "services_offered", label: "Servicios ofrecidos por la persona moral", type: "string" },
  { key: "shareholders", label: "Accionistas", type: "array" },
  { key: "administrators", label: "Administrador", type: "array" },
  { key: "legal_representative", label: "Representante Legal", type: "array" }
];

export const filterCrm = [
  { tab: "contact", key: "name", label: "Nombre" },
  { tab: "contact", key: "email", label: "Email" },
  { tab: "contact", key: "phone", label: "Teléfono" },
  { tab: "company", key: "company_name", label: "Nombre de empresa" },
  { tab: "company", key: "email", label: "Email" },
  { tab: "company", key: "company_phone", label: "Teléfono" },
  { tab: "company_group", key: "group_name", label: "Nombre del Grupo" },
];

export const afbInvestmentCreate = [
  { key: "customer_uuid", label: "UUID del cliente", fullWidth: true},
  { key: "unit_of_duration", label: "Unidad de periodo", catalog: "unit", section: "metadata"},
  { key: "duration", label: "Periodo", type: "number", section: "metadata"},
  { key: "rate_of_return", label: "Porcentaje del beneficio", type: "number", section: "metadata"},
  { key: "amount", label: "Monto de pago inicial", type: "number", section: "metadata"},
];

export const afbInvestmentComplete = [
  { key: "uuid", label: "ID de Inversión", fullWidth: true},
  { key: "tx_return_funds", label: "TX de pago inicial", section: "metadata", fullWidth: true},
  { key: "tx_earnings", label: "TX de beneficio pactado", section: "metadata", fullWidth: true},
  { key: "actual_earnings", label: "Rendimiento de la inversión", type: "number", section: "metadata"},
];

export const statusTxsPending = [
  { key: 'pending', label:'Pendiente'},
  { key: 'validated', label:'Validado'},
  { key: 'proccesed', label:'Procesado'}
];

export const filterTxsPending = [
  { key: 'tracking_key', label:'Tracking Key'},
  { key: 'space', label:'Space'},
  { key: 'uuid', label:'UUID'}
];

export const originTxsPending = [
  { key: 'spei', label:'SPEI'},
  { key: 'banxico_spei', label:'Banxico SPEI'},
  { key: 'LinkPayClip', label:'LinkPayClip'},
  { key: 'palla', label:'Palla'},
  { key: 'cashin', label:'Cashin'},
  { key: 'DeductAdjustment', label:'Deduct Adjustment'},
  { key: 'LoadAdjustment', label:'Load Adjustment'}
];

export const afbAdminInfo = [
  { key: "name", label: "Nombre" },
  { key: "email", label: "Correo" },
  { key: "phone", label: "Teléfono" },
  { key: "cdate", label: "Usuario desde" },
];

export const afbAdminEdit = [
  { section: "admin", key: "gname", label: "Nombre(s)", required: true },
  { section: "admin", key: "lname", label: "Apellido paterno", required: true },
  { section: "admin", key: "slname", label: "Apellido Materno", required: true },
  { section: "admin", key: "email", label: "Correo", required: true },
  { section: "admin", key: "phone", label: "Teléfono", required: true },
];

export const afbActions = [
  { key: "editAdmin", label: "Editar usuario aFB", icon: "Edit", status: "enabled"},
  { key: "dataReuseAfb", label: "Liberar datos", icon: "ContactPageSharp", status: "disabled", validation: '_REUSADO'},
  { key: "resendEmail", label: "Reenviar email 3FA", icon: "ForwardToInbox"},
  { key: "resendEmailCS", label: "Reenviar email 3FA", icon: "MarkEmailRead"},
  { key: "restoreSession", label: "Validar sesión", icon: "AdminPanelSettings"},
  { key: "otpTokenGetAllowed", label: "Desvincular albo token", icon: "LeakRemove", status: "enabled"},
  { key: "alboToken", label: "Habilitar albo token", icon: "AdbOutlined", status: "enabled"},
  { key: "alboTokenByEmail", label: "Activar albo token vía email", icon: "QrCodeScanner", status: "enabled"},
];
export const afbOrderOptions = [
  // { key: "cdate_last", label: "Creación: Más antiguo primero"},
  // { key: "cdate_first", label: "Creación: Más reciente primero"},
  // { key: "udate_last", label: "Actualización: Más antiguo primero"},
  // { key: "udate_first", label: "Actualización: Más reciente primero"},
  { key: "name_a", label: "Título de la empresa: A-Z"},
  { key: "name_z", label: "Título de la empresa: Z-A"}
];

export const afbSearchOptions = [
  { key: 'uuid', label:'UUID'},
  { key: 'clabe', label:'CLABE'},
  { key: 'email', label:'Email'}
];

export const afbRecurringFrecuency = [
  { key: 'HOUR', label:'Por hora'},
  { key: 'DAILY', label:'Diaria'},
  { key: 'WEEKLY', label:'Semanal'},
  { key: 'MONTHLY', label:'Mensual'},
  { key: 'HOURLY_LABORAL_WEEK', label:'Por hora - De Lun. a Vie'},
  { key: 'DAILY_LABORAL_WEEK', label:'Diario - De Lun. a Vie'}
];

export const afbRecurringType = [
  { key: 'TOTAL', label:'Total'},
  { key: 'FIXED', label:'Fija'},
  { key: 'PERCENTAGE', label:'Porcentaje'}
];

export const queueManagerActions = [
  { key: 'queueManagerActivate', label: 'Activar/Desactivar encolamiento manual de SPEI de salida'},
  // { key: 'queueManagerCountTask', label: 'Contar tareas'},
  { key: 'queueManagerPause', label: 'Pausar el dispatcher del encolamiento'},
  { key: 'queueManagerResume', label: 'Continuar el dispatcher del encolamiento'},
  { key: 'queueManagerUpdateRate', label: 'Ajustar tasa de límite por minuto del despachador de la cola de SPEI de salida'}
];